import service from '@/api/templates';
import {loading, alert, handleError} from '@/state/generators/helpers';

export const state = {
    service: service('admin/therapy-templates')
};

export const actions = {
    update: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.update(id, data).then(response => {
            commit('REPLACE_ITEM', response.data);
            commit('SET_ITEM', response.data);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    addComponent: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.addComponent(id, data).then(response => {
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.creation_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    updateComponent: function ({commit, state}, {id, componentId, data}) {
        loading(commit);

        return state.service.updateComponent(id, componentId, data).then(response => {
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    destroyComponent: function ({commit, state}, {id, componentId}) {
        loading(commit);

        return state.service.destroyComponent(id, componentId).then(() => {
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.deletion_is_successful'));
            loading(commit, false);
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    publish: function ({commit, state}, id) {
        loading(commit);

        return state.service.publish(id).then(response => {
            commit('REPLACE_ITEM', response.data);
            commit('SET_ITEM', response.data);
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    }
};
